import {
  REQUEST_USER,
  GET_USER,
  USER_ERROR,
  CLEAR_USER,
  GET_USER_BY_ID,
  USER_ERROR_BY_ID,
  UPDATE_EMAIL_CLEAR,
  UPDATE_EMAIL_ERROR,
  UPDATE_EMAIL_SUCCESS
} from "../action/types";

const initialState = {
  user: null,
  userById: null,
  loading: true,
  emailUpdateError: false,
  emailUpdateSuccess: false,
  error: {},
  // // umVersion: process.env?.REACT_APP_UM_VERSION ?? customConfig.umV1Version,
  // // umMobileUsersVersion: process.env?.REACT_APP_MOBILE_USERS_VERSION ?? customConfig.umV1Version,
  // umAuthToken: ''
};

export default function User(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case REQUEST_USER:
      return {
        ...state,
        loading: true,
      };
    case GET_USER:
      return {
        ...state,
        user: payload,
        loading: false,
      };
    case USER_ERROR:
      return {
        ...state,
        user: payload,
        loading: false,
      };
    case CLEAR_USER:
      return {
        ...state,
        user: null,
        loading: false,
      };
    case GET_USER_BY_ID:
      return {
        ...state,
        userById: payload,
        loading: false,
      };
    case USER_ERROR_BY_ID:
      return {
        ...state,
        userById: payload,
        loading: false,
      };
    case UPDATE_EMAIL_CLEAR:
      return {
        ...state,
        emailUpdateError: false,
        emailUpdateSuccess: false,
      };
    case UPDATE_EMAIL_ERROR:
      return {
        ...state,
        emailUpdateError: true,
        emailUpdateSuccess: false,
      };
    case UPDATE_EMAIL_SUCCESS:
      return {
        ...state,
        emailUpdateError: false,
        emailUpdateSuccess: true,
      };
    default:
      return state;
  }
}
